import { render, staticRenderFns } from "./StatisticsMerchant.vue?vue&type=template&id=546ab698&scoped=true&"
import script from "./StatisticsMerchant.vue?vue&type=script&lang=js&"
export * from "./StatisticsMerchant.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsMerchant.vue?vue&type=style&index=0&id=546ab698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546ab698",
  null
  
)

export default component.exports